export const dcrSearchCtaStyles = {
	root: {
		display: 'flex',
		alignItems: 'center',
		gap: 2,
		padding: 2,
		margin: 2,
		backgroundColor: '#eef7fe',
		borderRadius: 1,
		width: 'calc(100% - (4 * var(--mui-spacing)))'
	},
	icon: {
		height: 92,
		width: 92
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 1.5,
		width: '100%'
	},
	header: {
		fontWeight: 700,
		fontSize: 20,
		lineHeight: 1
	},
	caption: {
		fontSize: 16,
		lineHeight: 1
	},
	button: {
		backgroundColor: 'background.paper',
		fontWeight: 700
	}
};
